import * as React from 'react';
import get from 'lodash/get';
import { columnName, tableName } from 'app/area/case/case-data-model';

type WithAddDisabledUntilEgressedOwnProps = {
  childEntities?: any[];
};

const egressTimeField = columnName[tableName.involvedPersonInside].egressTime;

const hasEnabledEntry = (rows: any[] = []) => rows.some(row => !get(row, `${egressTimeField}[0].value`));

/**
 * Disables the add button of an entry log tile view while any of its entries is still open,
 * i.e. has no egress time. A new entry can only be added once every entry has been egressed.
 * 
 */
export const withAddDisabledUntilEgressed = <P extends WithAddDisabledUntilEgressedOwnProps>(
  WrappedComponent: React.ComponentClass<P> | React.FC<P>
) => {
  return class extends React.PureComponent<P> {
    public render() {
      const { childEntities, ...rest } = this.props as any;
      const injectedProps = { ...rest, disableAddButton: hasEnabledEntry(childEntities) } as P;

      return <WrappedComponent {...injectedProps} />;
    }
  };
};
